import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { injectIntl, WrappedComponentProps } from '@kyruus/intl';
import { PMCConfig } from '@kyruus/types';
import {
  ExtendedProvider,
  FullAppointmentInfo,
  SearchSummary
} from 'Src/types';
import { CtaListItem } from './CtaListItem';
import { DefaultCtaListItems, messages, useBookOnlineButton } from '../../lib';

interface BaseBookOnlineProps {
  provider: ExtendedProvider;
  config: PMCConfig;
  apptOptions?: FullAppointmentInfo;
  searchSummary?: SearchSummary;
  trackListItemClick: (listItem: DefaultCtaListItems) => void;
}

type BookOnlineProps = BaseBookOnlineProps &
  WrappedComponentProps &
  RouteComponentProps;

const BookOnlineComponent = injectIntl(
  ({
    provider,
    config,
    apptOptions,
    searchSummary,
    history,
    location,
    trackListItemClick,
    intl
  }: BookOnlineProps) => {
    const buttonProps = useBookOnlineButton({
      provider,
      config,
      apptOptions,
      searchSummary,
      location,
      history,
      trackListItemClick
    });

    const primaryText = intl.formatMessage(messages.bookOnlineTitle);
    const secondaryText =
      intl.formatMessage(messages.bookOnlineSubtitle) === ' '
        ? undefined
        : intl.formatMessage(messages.bookOnlineSubtitle);

    const isExternalLink = buttonProps?.target === '_blank';
    return (
      <CtaListItem
        buttonProps={buttonProps}
        isExternalLink={isExternalLink}
        primaryText={primaryText}
        secondaryText={secondaryText}
      />
    );
  }
);

export const BookOnline = withRouter(BookOnlineComponent) as any as (
  props: BaseBookOnlineProps
) => React.ReactElement;
